<template>
    <div>
        <CashflowChart v-if="!loading && chartData" :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import CashflowChart from '@/components/dashboard/charts/Cashflow'

export default {
    name: 'CashflowReportChart',
    components: {CashflowChart},
    props: {
        chartData: {
            type: Object,
            default: () => {}
        },
        loading: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            chartOptions: {
                title: { display: false },
                scales: {
                    xAxes: [{
                        time: {
                            displayFormats: {
                                quarter: ' YYYY'
                            }
                        },
                        stacked: true,
                        beginAtZero: true,
                        barPercentage: 0.9,
                        id: 'x-axis-label',
                        position: 'bottom',
                        scaleStartValue: 50,
                        gridLines: {
                            display: false
                        },
                    }],
                    yAxes: [{
                        stacked: true,
                        id: 'y-axis-label',
                        ticks: {
                            beginAtZero: true,
                            callback: (value) => {
                                return '€ ' + this.$options.filters.formatNumberInt(value)
                            }
                        },
                        position: 'left',
                        gridLines: {
                            color: "#f9f9f9",
                            display: true,
                            drawBorder: false,
                            zeroLineColor: "#e5e5e5",
                            zeroLineWidth: 1
                        },
                    }]
                },
                legend: {
                    display: false,
                    position: 'bottom'
                },
                maintainAspectRatio: false,
                scaleBeginAtZero: true,
                tooltips: {
                    callbacks: {
                            title: (tooltipItem, data) => {
                            return data['labels'][tooltipItem[0]['index']] + ' ' + data['datasets'][tooltipItem[0]['datasetIndex']]['label'];
                        },
                            label: (tooltipItem) => {
                            return '€ ' + this.$options.filters.formatNumberInt(tooltipItem.value)
                        }
                    },
                    backgroundColor: '#22AC8A', // $colorBrand
                    titleFontSize: 14,
                    cornerRadius: 8,
                    titleFontColor: '#ffffff',
                    bodyFontColor: '#ffffff',
                    bodyFontSize: 14,
                    displayColors: false
                }
            }
        }
    }
}
</script>

<style scoped>
</style>